import { render, staticRenderFns } from "./UserProjects.vue?vue&type=template&id=4bf2bd4e&scoped=true"
import script from "./UserProjects.vue?vue&type=script&lang=js"
export * from "./UserProjects.vue?vue&type=script&lang=js"
import style0 from "./UserProjects.vue?vue&type=style&index=0&id=4bf2bd4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf2bd4e",
  null
  
)

export default component.exports